import React from 'react';
import { useTranslation } from 'react-i18next';
import { Column } from '../base/grid';
import { P } from '../base/typography';
import { StyledErrorMessage } from '../uploadFiles/uploadFiles.styles';

interface Props {
	errorMessage: string;
}

export default function ErrorMessage({ errorMessage }: Props) {
	const { t } = useTranslation('generalForm');

	return (
		<Column>
			<P marginBottom="2rem">{`${t('thereWasAnError')}`}</P>
			<StyledErrorMessage>{errorMessage}</StyledErrorMessage>
		</Column>
	);
}
